module.exports = __webpack_public_path__ + "img/5fcc2985e17d9779432660a99f1a64df.25bcf9cc.jpg";